<script setup lang="ts">
import { useHead } from '@unhead/vue'
import { baseHead } from '@/lib/seo'
import { useRoute } from 'vue-router'

const route = useRoute()
useHead(() => ({
  ...baseHead({
    title: 'Page introuvable - Les Ateliers du Terras',
    description: "La page demandée n'existe pas ou a été déplacée.",
    canonical: route.path,
    index: false,
  }),
}))
</script>

<template>
  <section class="nf">
    <div class="container nf__in">
      <span class="nf__code">404</span>
      <h1>Cette page est introuvable</h1>
      <p>
        La page que vous cherchez n'existe pas ou a été déplacée. Retrouvez nos prestations depuis
        l'accueil ou contactez-nous directement.
      </p>
      <div class="nf__actions">
        <router-link to="/" class="btn btn--primary">Retour à l'accueil</router-link>
        <router-link to="/contact-2/" class="btn btn--outline">Nous contacter</router-link>
      </div>
    </div>
  </section>
</template>

<style scoped>
.nf {
  padding: 80px 0;
  text-align: center;
}
.nf__in {
  max-width: 600px;
}
.nf__code {
  font-family: var(--font-title);
  font-size: 4rem;
  font-weight: 800;
  color: var(--green-dark);
}
.nf__actions {
  display: flex;
  gap: 12px;
  justify-content: center;
  flex-wrap: wrap;
  margin-top: 20px;
}
</style>
